import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import AnrealageVR from "../views/AnrealageVR.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: AnrealageVR
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router
